import { DatoAssets } from '@components/Content/Assets'
import { DownloadApp } from '@components/DownloadApp'
import { Button } from '@components/Elements/Button'
import { ModalLayout } from '@components/Layouts'
import { useDebounce } from '@lib/hooks'
import { useI18n } from '@lib/i18n'
import { TrackingEvent, trackEvent } from '@lib/tracking'
import { useNavigation } from '@react-navigation/native'
import { useAuthStore } from '@stores/auth'
import { useEffect, useState } from 'react'
import styled from 'styled-components/native'

const Wrapper = styled.View`
  padding: ${({ theme }) => `10px ${theme.width < 380 ? 20 : 40}px`};
`
const ButtonWrapper = styled.View`
  align-items: center;
  margin: 20px 0;
  padding-top: 30px;
  border-top-width: 2px;
  border-color: ${({ theme }) => theme.colors.border};
`

export function WelcomeModal() {
  const t = useI18n()
  const navigation = useNavigation()
  const [user, updateAccount, getWelcome, welcome] = useAuthStore((state) => [
    state.user,
    state.updateAccount,
    state.getWelcome,
    state.welcome,
  ])
  const [isLoading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true)
    getWelcome().finally(() => setLoading(false))
    trackEvent(TrackingEvent.welcomeOpened)
  }, [])

  function updateFlags(): void {
    updateAccount({
      flags: { ...user?.flags, welcome: false },
    })
  }

  const handleCancelPressed = useDebounce(() => {
    updateFlags()
    trackEvent(TrackingEvent.welcomeCancelPressed)
  }, [user])

  const handleGotItPressed = useDebounce(() => {
    updateFlags()
    navigation.goBack()
    trackEvent(TrackingEvent.welcomeGotItPressed)
  }, [user])

  return (
    <ModalLayout title={''} onCancel={handleCancelPressed} isLoading={isLoading}>
      <Wrapper>
        {welcome && (
          <>
            <DatoAssets assets={welcome.content} />
            <DownloadApp />
            <ButtonWrapper>
              <Button onPress={handleGotItPressed} label={t('actions.gotIt')} />
            </ButtonWrapper>
          </>
        )}
      </Wrapper>
    </ModalLayout>
  )
}
